import { render, staticRenderFns } from "./ListedBuilding.vue?vue&type=template&id=4f29ec7a"
import script from "./ListedBuilding.vue?vue&type=script&lang=js"
export * from "./ListedBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports